import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Icon from 'srcReact/components/icons/Icon'

const QuickActionsSection = ({ isEmpty, workplaceId }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.quickActionContainer}>
      <div className={styles.sectionTitle}>{t('dashboard.quickActions.title')}</div>
      <div className={styles.actions}>
        <AnchorLink
          className={styles.action}
          isReactLink={false}
          path={`/0/workplace/settings/${workplaceId}?section=link_2`}>
          <div className={styles.iconWrapper}>
            <Icon name='send' size='xlarge' styleModifier={styles.actionIcon} />
          </div>
          <span className={styles.text}>{t('global.inviteMembers')}</span>
        </AnchorLink>
      </div>
    </div>
  )
}

export default QuickActionsSection
